<button
  data-at-close-overlay-btn
  mat-stroked-button
  class="close-btn-overlay lt-md:!hidden"
  [viConfirm]="viConfirmObject"
  (confirm)="confirm()"
  (cancel)="cancel()"
  (click)="close()"
>
  <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
  <mat-icon iconPositionEnd>close</mat-icon>
</button>
<button
  data-at-close-overlay-btn
  mat-icon-button
  class="close-btn-small !hidden lt-md:!inline-flex"
  [viConfirm]="viConfirmObject"
  (confirm)="confirm()"
  (cancel)="cancel()"
  (click)="close()"
>
  <mat-icon>close</mat-icon>
</button>
